/**
 * Cart page — dynamic recommendations below line items.
 */
(function () {
  'use strict';

  function parseIds(value) {
    if (!value) return [];
    return value.split(',').map(function (id) {
      return Number(id);
    }).filter(function (id) {
      return !isNaN(id);
    });
  }

  function moneyFormat() {
    return document.body.getAttribute('data-money-format') || '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat());
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function firstAvailableVariant(variants) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0];
  }

  function inIdList(list, id) {
    var target = Number(id);
    return list.some(function (entry) {
      return Number(entry) === target;
    });
  }

  function visibleProductIds(grid) {
    var ids = parseIds(grid.getAttribute('data-cart-product-ids'));
    grid.querySelectorAll('[data-product-id]').forEach(function (el) {
      var id = Number(el.getAttribute('data-product-id'));
      if (!isNaN(id) && !inIdList(ids, id)) ids.push(id);
    });
    return ids;
  }

  function productList(grid) {
    return grid.querySelector('.cart-recommendations__products');
  }

  function hideCartProducts(grid) {
    var excluded = parseIds(grid.getAttribute('data-cart-product-ids'));
    if (!excluded.length) return;

    var list = productList(grid);
    if (!list) return;

    list.querySelectorAll('.hp-product-row__card[data-product-id]').forEach(function (card) {
      var productId = Number(card.getAttribute('data-product-id'));
      if (inIdList(excluded, productId)) {
        card.style.display = 'none';
      }
    });
  }

  function trimVisibleProducts(grid, limit) {
    var list = productList(grid);
    if (!list) return 0;

    var cards = Array.prototype.slice.call(
      list.querySelectorAll('.hp-product-row__card[data-product-id]')
    ).filter(function (card) {
      return card.style.display !== 'none';
    });

    cards.forEach(function (card, index) {
      if (index >= limit) card.style.display = 'none';
    });

    return cards.filter(function (card, index) {
      return index < limit;
    }).length;
  }

  function fetchRecommendationsWithIntent(productId, limit, intent) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=' + intent, {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations failed');
        return res.json();
      })
      .then(function (data) {
        return data.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function fetchRecommendations(productId, limit) {
    return fetchRecommendationsWithIntent(productId, limit, 'complementary').then(function (products) {
      if (products.length >= limit) return products.slice(0, limit);

      var remaining = limit - products.length;
      if (remaining <= 0) return products;

      return fetchRecommendationsWithIntent(productId, remaining + products.length, 'related').then(function (related) {
        related.forEach(function (product) {
          if (products.length >= limit) return;
          var exists = products.some(function (existing) {
            return Number(existing.id) === Number(product.id);
          });
          if (!exists) products.push(product);
        });
        return products.slice(0, limit);
      });
    });
  }

  function recommendationCardHtml(product) {
    var variant = firstAvailableVariant(product.variants);
    if (!variant) return '';

    var image = product.featured_image
      ? product.featured_image.replace(/(\.[^.]+)$/, '_400x$1')
      : '';
    var price = formatMoney(variant.price);

    return ''
      + '<li class="hp-product-row__card" data-product-id="' + product.id + '">'
      + '<a class="hp-product-row__link" href="/products/' + escapeHtml(product.handle) + '">'
      + '<div class="hp-product-row__image-wrap">'
      + (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '')
      + '</div>'
      + '<div class="hp-product-row__details">'
      + '<h3 class="hp-product-row__title">' + escapeHtml(product.title) + '</h3>'
      + '<p class="hp-product-row__price">' + price + '</p>'
      + '</div>'
      + '</a>'
      + '<div class="hp-product-row__actions">'
      + '<form method="post" action="/cart/add" class="product-form hp-product-row__form" enctype="multipart/form-data" data-product-id="' + product.id + '">'
      + '<input type="hidden" name="id" value="' + variant.id + '">'
      + '<button type="button" name="add" class="global-button global-button--primary hp-product-row__cta product-form__submit">Add to cart</button>'
      + '</form>'
      + '</div>'
      + '</li>';
  }

  function renderDynamicProducts(grid, products, excludedIds, limit, existingCount) {
    var list = productList(grid);
    if (!list) return;

    var added = 0;

    products.forEach(function (product) {
      if (existingCount + added >= limit) return;
      if (inIdList(excludedIds, product.id)) return;

      var duplicate = list.querySelector('.hp-product-row__card[data-product-id="' + product.id + '"]');
      if (duplicate && duplicate.style.display !== 'none') return;

      list.insertAdjacentHTML('beforeend', recommendationCardHtml(product));
      added += 1;
    });
  }

  function initGrid(grid) {
    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 4;
    var useDynamic = grid.getAttribute('data-use-dynamic') === 'true';
    var anchorId = parseInt(grid.getAttribute('data-anchor-product-id'), 10);
    var excludedIds = visibleProductIds(grid);

    hideCartProducts(grid);
    var visibleCount = trimVisibleProducts(grid, limit);

    if (!useDynamic || !anchorId || visibleCount >= limit) return;

    fetchRecommendations(anchorId, limit - visibleCount + 2).then(function (products) {
      renderDynamicProducts(grid, products, excludedIds, limit, visibleCount);
    });
  }

  function onDocumentClick(event) {
    var button = event.target.closest('.cart-recommendations .hp-product-row__cta[name="add"]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var form = button.closest('form');
    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Adding…';

    var addPromise = window.YTAddToCart && typeof window.YTAddToCart.add === 'function'
      ? window.YTAddToCart.add({ id: variantId, quantity: 1 })
      : fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        });

    addPromise
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Add to cart';
      });
  }

  function init() {
    document.querySelectorAll('[data-cart-recommendations-grid]').forEach(initGrid);
    document.addEventListener('click', onDocumentClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
